module.exports = __webpack_public_path__ + "static/media/flechaAbajo.a05d31ed.svg";